import SystemFieldProto from '../../proto/system-field-proto'

// not an actual field yet, just a stub for board preferences

export default class TodoField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType)
        this.type = gd.const.fields.type.TODO_LIST
    }

    get sortHintMessage() {
        return 'Sort by todo'
    }

    getCsvValue(item) {
        return "todo list csv value is not implemented"
    }

    getValue(item) {return item.checklist}
}
